import { Component, Vue } from 'vue-property-decorator';
import WithRender from './ReferralCommissionReport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  },
  computed: {
    ...mapGetters("originatorStore", { currency: "getWalletCurrency" }),
  }
})
export default class ReferralCommissionReport extends Vue {

  isLoading = false;
 
  items = [];

  fields = [
    {
      key: "createdOn",
      label: "Created On",
      sortable: true,
    },
    {
      key: "lastPayoutDate",
      label: "Last Payout",
      sortable: true,
    },
    {
      key: "referrorAgentCode",
      label: "Agent Code",
      sortable: true,
    },
    {
      key: "referrorName",
      label: "Name",
      sortable: true,
    },
    {
      key: "balanceAsAt",
      label: "Balance As At",
      sortable: true,
    },
    {
      key: "balance",
      label: "Opening balance",
      sortable: true,
    },
    {
      key: "commissionPaid",
      label: "Commission Paid",
      sortable: true,
    },
    {
      key: "currentCommission",
      label: "Current Commission",
      sortable: true,
    },
    {
      key: "outStandingAmount",
      label: "OutStanding Amount",
      sortable: true,
    },
    {
      key: "referrorUserId",
      label: "",
    }
  ]

  customFormatter(date: Date) {
    return moment(date).format('yyyy-MM-DD');
  }

  customFormatterWithTime(date: Date) {
    return moment(date).format('yyyy-MM-DD HH:mm:ss');
  }
  mounted() {
    this.getReport();
  }

  badgeVarient(value: string): string {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const inputDate = new Date(value)
    if (inputDate >= today)
      return "success";
  }

  buttonVarient(value: string): string {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const inputDate = new Date(value)
    if (inputDate >= today)
      return "btn btn-success";
    return "btn btn-default";
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/ReferalTransactionStatus/GetAllAgentsSummary`)
      .then(response => {
        this.items = response.data;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
